module.exports = __webpack_public_path__ + "img/phone-logo.97769d0e.png";